export const GET_GROCERIES_REQUEST = "GET_GROCERIES_REQUEST";
export const GET_GROCERIES_SUCCESS = "GET_GROCERIES_SUCCESS";
export const GET_GROCERIES_ERROR = "GET_GROCERIES_ERROR";
